module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ornament-prect"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ornament.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "prect",
    attrs: {
      "id": "char"
    }
  }, [_c('a', {
    attrs: {
      "id": "pX"
    }
  }), _vm._v("PRINCIPAL CHARACTERS")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Some of the following classifications are somewhat schematic. There were overlaps: for instance, Marie-Antoinette’s social group, the Polignacs, were also the king’s political supporters often in opposition to the queen. I have placed Robespierre among the republicans but as late as 1791 he thought the declaration of republic would be aristocratic. Lafayette and the Girondins were doctrinaire republicans but when it came to the crunch tried to save the monarchy – ineffectively, because their heart wasn’t in it.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("THE AUSTRIAN ROYAL FAMILY")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Francis I, Holy Roman Emperor 1745–65.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Maria-Theresa, his wife, queen of Bohemia and Hungary in her own right, 1740–80.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Joseph I, their eldest son, Holy Roman Emperor 1765–90 and co-ruler with his mother.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Leopold II, their second son, grand duke of Tuscany then Holy Roman Emperor 1790–2.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Marie-Antoinette, their youngest daughter, b. 1755, archduchess of Austria, then dauphine of France 1770–4 and queen of France 1774–92.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("THE FRENCH ROYAL FAMILY")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Louis XV, king of France 1715–74.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Maria Leszcyńska, his wife, d. 1768.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Madame de Pompadour, his "), _c('i', [_vm._v("maîtresse-en-titre")]), _vm._v(", d. 1764.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Madame du Barry, his "), _c('i', [_vm._v("maîtresse-en-titre")]), _vm._v(" 1768–74.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Louis-Ferdinand, his only son, the ‘old dauphin’, d. 1765.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Adélaïde and Victoire, his daughters, known as Mesdames Tantes under Louis XVI.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_c('a', {
    attrs: {
      "id": "pXI"
    }
  }), _vm._v("Louis-Auguste, eldest surviving son of Louis-Ferdinand: dauphin 1765–74, king of France 1774–92.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Louis Stanislas Xavier, his next brother, comte de Provence, known as ‘Monsieur’, then Louis XVIII 1813–24.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Charles-Philippe, the next brother, comte d’Artois then Charles X 1824–30.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Elizabeth of France, their sister, known as Madame Elizabeth, guillotined 1794.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("THE CHILDREN OF LOUIS XVI AND MARIE-ANTOINETTE")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Louis-Joseph, the ‘first dauphin’ 1781–9.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Louis-Charles, the ‘second dauphin’ 1785–95, sometimes called Louis XVII 1793–5.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Marie-Thérèse-Charlotte, Madame Royale 1778–1854, their eldest child.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Sophie, 1786–7.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("MARIE-ANTOINETTE’S SOCIAL CIRCLE, THE POLIGNAC SET")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Yolande de Polastron, comtesse then duchesse de Polignac, governess of the royal children 1782–9.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Armand, comte then duc de Polignac, Yolande’s husband, "), _c('i', [_vm._v("Surintendant des postes")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Diane de Polignac, Armand’s sister, the brains behind the group.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Vaudreuil, Joseph Hyacinthe, comte de, lover of Madame de Polignac.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Adhémar, Jean-Balthazar, comte d’, ambassador to the Court of Saint-James, 1783–7.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Calonne, Charles-Alexandre de, finance minister 1783–7.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Artois, Charles-Philippe, comte d’.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("MARIE-ANTOINETTE’S POLITICAL CIRCLE")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Breteuil, Louis Auguste, baron de, minister of the household 1783–8, head of the ‘ministry of the hundred hours’ 12–14 July 1789.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Castries, Charles-Eugène, marquis de, minister of the Marine, 1780–7.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Choiseul, Étienne-François, duc de, foreign minister 1757–61, dominant minister in the 1760s, arranged Marie-Antoinette’s marriage to the dauphin.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Guines, Adrien-Louis, comte then duc de, ambassador to London 1770–6.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Ségur, Philippe Henri, marquis de, minister for war 1780–7.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Loménie de Brienne, Étienne-Charles de, Archbishop of Toulouse, prime minister 1787–8.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Mercy-Argenteau, Florimond, comte de, Austrian ambassador, 1766–89.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_c('a', {
    attrs: {
      "id": "pXII"
    }
  }), _vm._v("Necker, Jacques, finance minister 1776–81, de facto prime minister 1788–9.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Vermond, Jacques-Mathieu, abbé de, Marie-Antoinette’s tutor.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("THE KING’S PARTY")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Calonne, Charles-Alexandre de, finance minister 1783–7.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Maurepas, Frédéric comte de, minister for the household 1718–23, minister for the Marine 1723–49, de facto prime minister 1774–81.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Montmorin, Armand Marc, comte de, foreign secretary 1787–91.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Vergennes, Charles Gravier, comte de, foreign secretary 1774–87.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_c('i', [_vm._v("And the Polignac set in general, as above.")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("REVOLUTIONARY LEADERS")]), _vm._v(" "), _c('p', {
    staticClass: "bhd-below"
  }, [_c('i', [_vm._v("Constitutional Monarchists")])]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Barnave, Antoine, deputy in the Constituent Assembly.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Duport, Adrien, "), _c('i', [_vm._v("parlementaire")]), _vm._v(" then deputy in the Constituent Assembly.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Lameth, Alexandre comte de, courtier then deputy in the Constituent Assembly.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_c('i', [_vm._v("The above three known as ‘the triumvirs’.")])]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Duport de Tertre, Marguerite-Louis-François, minister of justice, 1790–2. The conduit for the implementation of Marie-Antoinette and Barnave’s policy in 1791.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Lafayette, Gilles, marquis de, commander of the Parisian National Guard, determined enemy of Marie-Antoinette whom he blamed for stiffening the king’s resistance to the Revolution.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Mirabeau, Honoré Gabriel, comte de, journalist, deputy in the Constituent Assembly, secret adviser to Marie-Antoinette.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Mounier, Jean Joseph, deputy in the Constituent Assembly. Supported a strong constitutional monarchy and seceded from the National Assembly in protest at the October Days.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Malouet, Pierre Victoire, deputy in the Constituent Assembly. Supported a strong constitutional monarchy.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Narbonne, Louis comte de, minister of war 1791–2. Lover of Madame de Staël, advocated war.")]), _vm._v(" "), _c('p', {
    staticClass: "bhd"
  }, [_c('i', [_vm._v("Republicans")])]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Pétion, Jérôme, deputy, mayor of Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Robespierre, Maximilien, deputy, member of the Committee of Public Safety. It was his influence which sent Marie-Antoinette before the Revolutionary Tribunal.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_c('a', {
    attrs: {
      "id": "pXIII"
    }
  }), _vm._v("David, Jacques-Louis, painter, deputy, member of the Committee of General Security.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Hébert, René, editor of "), _c('i', [_vm._v("Le Père Duchesne")]), _vm._v(", official in the Commune of Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Danton, Georges, deputy, member of the ‘first’ Committee of Public Safety.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Brissot, Jean-Pierre, deputy, the leader of the war party 1791–2.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Vergniaud, Pierre, deputy, Girondin associate of Brissot.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Fouquier-Tinville, Antoine Quentin, public prosecutor of the Revolutionary Tribunal which tried Marie-Antoinette.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Herman, Armand-Joseph, president of the Revolutionary Tribunal.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("OTHER CHARACTERS")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("D’Aiguillon, Emmanuel, duc, foreign secretary under Louis XV, and Marie-Antoinette’s first ‘scalp’ on becoming queen.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Fersen, Axel von, Swedish nobleman in the service of France, reputed lover of Marie-Antoinette.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Guéméné, Victoire-Armande, princesse de, governess of the royal children 1778–82. Marie-Antoinette once told her, ‘I will love you to my dying day’, but had her dismissed after the spectacular bankruptcy of her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Kaunitz, Wenzel Anton, prince von, Austrian chancellor 1753–92. Kaunitz discounted Marie-Antoinette’s utility to Austria, calling her a ‘bad payer’.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Lamballe, Marie Thérèse Louise of Savoy, princesse de, "), _c('i', [_vm._v("surintendant")]), _vm._v(" of the queen’s household. An early favourite, she returned to France at Marie-Antoinette’s request in 1791 and was killed in the September Massacres the next year.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Lamoignon, Chrétien-François de, president in the Parlement, justice minister 1787–8. Lamoignon organized the acquittal of Cardinal Rohan by the Parlement but Marie-Antoinette had to work closely with him a year later.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("La Motte-Valois, Jeanne, mastermind of the heist known as the Diamond Necklace Affair.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Noailles, Anne comtesse de, "), _c('i', [_vm._v("dame d’honneur")]), _vm._v(" (no. 2) in the queen’s household. Dubbed ‘Madame Etiquette’ by Marie-Antoinette, who also thought the power of the Noailles had become too entrenched.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Ossun, Geneviève de Gramont, comtesse de. Marie-Antoinette attended her salon when relations with Madame de Polignac became strained in 1787. Guillotined in 1794.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Rohan, Louis, cardinal de, ambassador to Vienna 1772–4, Grand Almoner 1777–86, hated by Marie-Antoinette and the dupe in the Diamond Necklace Affair.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_c('a', {
    attrs: {
      "id": "pXIV"
    }
  }), _vm._v("Staël, Germaine, Madame de, daughter of Necker, lover of Narbonne, she published an anonymous defence of Marie-Antoinette when she learned she was to be tried.")]), _vm._v(" "), _c('p', {
    staticClass: "chr"
  }, [_vm._v("Turgot, Anne-Robert-Jacques, distinguished economist and finance minister 1774–6. Marie-Antoinette threatened to have him thrown in the Bastille but her role in his downfall has been exaggerated.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e1ae258","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/list_of_principal_characters.vue
// module id = 75
// module chunks = 0